import React from 'react';
import { useLocation } from 'react-router-dom';

export function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export const openInNewTabGeneric = (url: string | undefined): void => {
  const newWindow = window.open(url, '_blank', 'noopener, noreferrer');
  if (newWindow) newWindow.opener = null;
};

export const isNumeric = (value: string) => {
  if (!value) return false;
  if (!Number(value)) {
    return false;
  }
  return true;
};

export const history = {
  navigate: null,
  location: null,
};
